export default "__VITE_ASSET__DAo1M7Jy__"